import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionSwap } from '../interfaces/swap_section_interface';
import { ITermCoursesDatasource } from '../../views/term_courses/datasources/term_courses_datasource';
import { RegistrationFailureModel } from '../../views/course_scheduler/models/registration_failure_model';
import { ISection } from '../../interfaces/scheduler_interfaces';

export class SwapCallbackServant {
  constructor(
    private updateSwapSectionStatusCommand: ICommand,
    private ngRegistrationFailureModel: RegistrationFailureModel,
    private ngTermCoursesDatasource: ITermCoursesDatasource
  ) {}

  swapSuccess(outcomeData: ISectionSwap): void {
    this.updateSwapSectionStatusCommand(outcomeData.swap_from_section_ids, '');
    this.updateSwapSectionStatusCommand(outcomeData.swap_to_section_ids, 'REGISTERED');
  }

  swapFails(outcomeData: ISectionSwap, previousSwapStatus: any = {}): void {
    this.addErrorToModel(outcomeData);
    this.updateSwapSectionStatusCommand(outcomeData.swap_to_section_ids, '');
    this.updateSwapSectionStatusCommand(outcomeData.swap_from_section_ids, previousSwapStatus);
  }

  addErrorToModel(outcomeData: ISectionSwap) {
    _4.forEach(outcomeData.swap_from_section_ids, (sectionId) =>
      this.ngRegistrationFailureModel.put({
        type: 'SWAP',
        id: sectionId,
        message: outcomeData.message
      })
    );
  }

  getCourseFromSection(section: ISection) {
    return this.ngTermCoursesDatasource.get(section.course);
  }
}

angular.module('capability-ng-scheduler').service('ngSwapCallbackServant', SwapCallbackServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/servants/section_swap_callback_servant.ts